import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { UPDATE_CONTACT } from '../constants/actions';
import type { TContactActionTypes } from '../types';
import type { IContact } from 'src/interfaces/contact';

export const updateContact = async (
    dispatch: Dispatch<TContactActionTypes>,
    contactId: string,
    body: Record<string, unknown>
): Promise<Partial<IContact> | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.put(
            `/contacts/${contactId}/update`,
            body,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: UPDATE_CONTACT,
            payload: res.data.data as IContact,
        });

        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
